import type { ReactNode } from 'react';
import SiteTile from '../../../Tile/SiteTile/SiteTile';
import {
  getAvatarIconColor,
  getSiteTileColor,
  type SiteTileColor,
} from '../../../Tile/siteTileColors';

/**
 * Anything a consent screen offers with an avatar: an Atlassian site, a
 * Bitbucket workspace. `name` is what the chip colour falls back to when the
 * avatar isn't one of the recognised icons.
 */
export type AvatarOption = {
  name: string;
  avatar?: string;
};

/**
 * `MultiSelect` accessors shared by the site and Bitbucket selectors, so the two
 * fields keep the same tile and the same chip palette without each restating
 * how to derive them.
 */
export const getAvatarOptionIcon = (item: AvatarOption): ReactNode => (
  <SiteTile avatarUrl={item.avatar} />
);

export const getAvatarOptionChipColor = (item: AvatarOption): SiteTileColor =>
  getAvatarIconColor(item.avatar) ?? getSiteTileColor(item.name);
